import React from 'react'

const SendDeals = () => {
  return (
    <div>
      SendDeals
    </div>
  )
}

export default SendDeals
